<template>
  <section class="step">
    <transition name="fadeDownBig" mode="out-in" appear>
      <div class="subtitle">{{ title }}&nbsp;—</div>
    </transition>
    <div class="section-inner">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style scoped>
.step {
  width: 100%;
  flex-grow: 1;
}

.section-inner {
  font-size: 1rem;
  width: 100;
}

.subtitle {
  width: 80%;
  margin-top: 25px;
  margin-bottom: 0.5em;
  font-size: 5em;
  font-weight: 600;
  line-height: 1em;
}

@media only screen and (max-width: 767px) {
  /* smartphone */
  .subtitle {
    font-size: 3em;
  }
}
</style>
